import Ajax from '@/lib/ajax_wrapper'

const SESSION_PATH = '/admin/auth'

/**
 * Create a session
 *
 * @param {object} user
 * @param {string} user.email
 * @param {string} user.password
 *
 * @returns {promise}
 */
export function createSession(user) {
  return Ajax.request({
    url: SESSION_PATH + '/identity/callback',
    method: 'POST',
    data: {user}
  })
}

/**
 * Refresh a session
 *
 * @param {object} session
 * @param {string} session.jwt
 *
 * @returns {promise}
 */
export function updateSession({token}) {
  return Ajax.request({
    url: SESSION_PATH,
    method: 'PATCH',
    data: {session: {token}}
  })
}

/**
 * Logout user
 *
 * @param {object} session
 * @param {string} session.jwt
 *
 * @returns {promise}
 */
export function deleteSession({token}) {
  return Ajax.request({
    url: SESSION_PATH,
    method: 'DELETE',
    data: {token}
  })
}
